// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2t0TQ","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3oYtu"};